module.exports = __webpack_public_path__ + "media/images/athletes/505-0d94b527b12f36202d172d2ed02a554d.png";